import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import AceEditor from "react-ace";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface SalamanderInboxXmlPageProps {
    tenantId: string;
    schoolCode: string;
    blobName: string;
    
    apiService: ApiService;
}

interface SalamanderInboxXmlPageState {
    dataShareItem?: string;
}

class SalamanderInboxXmlPage extends Component<SalamanderInboxXmlPageProps & DispatchProps, SalamanderInboxXmlPageState> {

    constructor(props: SalamanderInboxXmlPageProps & DispatchProps) {
        super(props);

        this.state = {
            dataShareItem: undefined,
        };
    }

    async componentDidUpdate(prevProps: Readonly<SalamanderInboxXmlPageProps & DispatchProps>, prevState: Readonly<SalamanderInboxXmlPageState>, snapshot?: any): Promise<void> {
        if (this.props.blobName !== prevProps.blobName) {
            await this.loadDatashareItem(this.props.blobName);
        }
    }

    async componentDidMount() {
        if (this.props.blobName) {
            await this.loadDatashareItem(this.props.blobName);
        }
    }
    

    private async loadDatashareItem(name: string | undefined) {

        this.setState({
            dataShareItem: undefined
        });

        if (name != undefined) {
            const blob = await this.props.apiService.getSalamaderDateshareItem(name);
            this.setState({
                dataShareItem: blob
            });
        }
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Salamander Inbox XML" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} /> 
                <div className={"card flex-item--flex-1"}>
                    <div className={"card__header"}>
                        <div className={"card__title"}>{this.props.blobName}</div>
                    </div>
                    <AceEditor
                        mode="xml"
                        value={this.state.dataShareItem === undefined ? "Loading" : this.state.dataShareItem}
                        name="xmlViewer"
                        width="100%"
                        height="100%"
                        wrapEnabled={true}

                        readOnly={true}
                    />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SalamanderInboxXmlPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const blobName = ownProps.match.params.blobName;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            blobName: blobName,

            apiService: state.auth.apiService
        };
    }
)(SalamanderInboxXmlPage);